function RepublicOfMacedonia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1951)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FFDA44"/>
  <path d="M18.4333 31.8161C21.0355 31.4191 23.4309 30.3943 25.4618 28.9024L16 16L18.4333 31.8161Z" fill="#D80027"/>
  <path d="M13.5666 0.183594C10.9645 0.580594 8.56909 1.60534 6.53809 3.09716L16 15.9997L13.5666 0.183594Z" fill="#D80027"/>
  <path d="M6.53809 28.9024C8.56896 30.3942 10.9643 31.419 13.5665 31.8161L16 16L6.53809 28.9024Z" fill="#D80027"/>
  <path d="M3.09752 6.53711C1.60565 8.56811 0.581023 10.9634 0.18396 13.5657L16 15.999L3.09752 6.53711Z" fill="#D80027"/>
  <path d="M0.18396 18.4333C0.58096 21.0355 1.60571 23.4309 3.09759 25.4618L16 16L0.18396 18.4333Z" fill="#D80027"/>
  <path d="M31.8161 13.5656C31.419 10.9634 30.3943 8.56805 28.9024 6.53711L16 15.9989L31.8161 13.5656Z" fill="#D80027"/>
  <path d="M25.4618 3.0971C23.4308 1.60528 21.0355 0.580594 18.4333 0.183594L16 15.9997L25.4618 3.0971Z" fill="#D80027"/>
  <path d="M28.9026 25.4618C30.3944 23.4309 31.4191 21.0354 31.8162 18.4333L16 16L28.9026 25.4618Z" fill="#D80027"/>
  <path d="M16 21.564C19.0736 21.564 21.5652 19.0724 21.5652 15.9988C21.5652 12.9252 19.0736 10.4336 16 10.4336C12.9264 10.4336 10.4348 12.9252 10.4348 15.9988C10.4348 19.0724 12.9264 21.564 16 21.564Z" fill="#D80027"/>
  <path d="M16 20.174C18.3052 20.174 20.1739 18.3053 20.1739 16.0001C20.1739 13.6949 18.3052 11.8262 16 11.8262C13.6948 11.8262 11.826 13.6949 11.826 16.0001C11.826 18.3053 13.6948 20.174 16 20.174Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default RepublicOfMacedonia;
